import { Controller } from '@hotwired/stimulus';

/*
 * DDT-4046: click-to-play facade for YouTube embeds.
 *
 * The eager embed pulled the whole player (~1 MB over 9 requests) on every page
 * view, watched or not. The markup now ships a thumbnail; this swaps in the real
 * player on the first click, with autoplay so the click still starts the video.
 */
/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        embedUrl: String,
        title: String,
    };

    play() {
        const player = document.createElement('iframe');
        const separator = this.embedUrlValue.includes('?') ? '&' : '?';

        player.src = `${this.embedUrlValue}${separator}autoplay=1`;
        player.title = this.titleValue;
        player.width = '100%';
        player.height = '600';
        player.frameBorder = '0';
        player.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        player.referrerPolicy = 'strict-origin-when-cross-origin';
        player.allowFullscreen = true;

        this.element.replaceWith(player);
    }
}
